import context from "react-bootstrap/esm/AccordionContext";

export const config = [
  {
    path: "/factfind",
    context: "The user is currently filling in their fact find form",
  },
  {
    path: "/annuityquotesquick",
    context:
      "The user has completed a quick quote with the minimum required information. They are likely looking at their current result and deciding whether to go on and complete a full quote, or book a free consultation",
  },
  {
    path: "/fullquotepartial",
    context:
      "The user is filling in a full quote which will require them to fill in more detailed information about themselves",
  },
  {
    path: "/overview",
    context: "The user is on the homepage",
  },
  {
    path: "/annuityquotes/refresh",
    context:
      "The user has filled in their full quote which has taken lots of detailed information about them. They are likely looking at their current options for lifetime annuities, fixed term annuities or flexi access drawdown",
  },
  {
    path: "/mydetails",
    context: "The user is on their my details page",
  },
  {
    path: "/mypensionreview",
    context:
      "The user is on their my pension review page. This is where they will be asked to fill in details about their pension. This is completed so that we can request specific information from their pension providers to allow us to make fully informed decisions regarding what's best for them",
  },
  {
    path: "/myquotes",
    context:
      "The user is on their my quotes page. This is where they will be able to view their quotes based on the details they have filled in",
  },
  {
    path: "/myapplication",
    context:
      "The user is on their my application page. This is where they will be able to view the status of their application and any next steps required",
  },
  {
    path: "/",
    context: "",
  },
];
